module.exports = __webpack_public_path__ + "static/coke-58e120fabc4146182f036ba891033685.svg";